module.exports = __webpack_public_path__ + "images/pro/head-bg-535a92faa8909f15b2935f0ad2788fc0.jpg";